/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Search_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Search voices…" |
*
* @param {Voice_Manager_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_search_placeholder = /** @type {((inputs?: Voice_Manager_Search_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Search_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher des voix…")
	if (locale === "de") return /** @type {LocalizedString} */ ("Stimmen suchen…")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cerca voci…")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Поиск голосов…")
	if (locale === "es") return /** @type {LocalizedString} */ ("Buscar voces…")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("搜索语音…")
	if (locale === "ja") return /** @type {LocalizedString} */ ("音声を検索…")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आवाज़ें खोजें…")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Pesquisar vozes…")
	return /** @type {LocalizedString} */ ("Search voices…")
});